import { IconTemplate } from '@components/Icon/IconTemplate';
import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0 ${rem(15)} 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
`;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors?.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors?.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const Sections = styled.div`
    display: flex;
    flex-direction: column;
    font-weight: ${({ theme }) => theme.fontWeights.textRegular};
    gap: ${rem(30)};

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
    }
`;

export const Contacts = styled.div`
    @media (min-width: ${breakpoints.sm}px) {
        width: 50%;
    }
`;

export const Map = styled.div`
    height: ${rem(500)};
    background: ${({ theme }) => theme.colors.darkLight};
    padding: ${rem(25)};
    position: relative;
    @media (min-width: ${breakpoints.sm}px) {
        width: 50%;
    }

    > div {
        height: 65% !important;
    }
`;

export const ContactSection = styled.div`
    margin-top: ${rem(20)};
`;

export const ContactSectionTitle = styled.span<{ withoutPaddingTop?: boolean }>`
    display: block;
    padding-top: ${(props) => (props.withoutPaddingTop ? 0 : rem(30))};
    padding-bottom: ${rem(5)};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
`;

export const ContactSectionTitlePlace = styled.span`
    display: block;
    padding-top: ${rem(0)};
    padding-bottom: ${rem(5)};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
`;

export const ContactSectionRow = styled.span<{ paddingTop?: number }>`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: ${(props) => (props.paddingTop ? rem(props.paddingTop) : 0)};

    @media (min-width: ${breakpoints.xs}px) {
        flex-direction: row;
    }
`;

export const ContactSectionPerson = styled.span`
    padding-bottom: ${rem(10)};
`;

export const ContactSectionAddress = styled.span`
    padding-bottom: ${rem(5)};
    display: block;
`;

export const ContactSectionIcon = styled(IconTemplate)<{ colors: IColors }>`
    margin-top: ${rem(4)};

    svg {
        width: ${rem(20)};
        height: ${rem(20)};

        path {
            fill: ${(props) => props.colors?.colorLine};
        }
    }
`;

export const ContactSectionLink = styled.a<{ colors: IColors }>`
    color: ${(props) => props.colors?.colorLink};
    cursor: pointer;
    padding-left: ${rem(10)};
    text-decoration: none;
`;

export const Coordinates = styled.span`
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    display: block;
    margin: ${rem(35)} 0 ${rem(10)} 0;
`;

export const PointIcon = styled.div`
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: ${rem(15)};
    top: ${rem(-30)};
`;

export const Icon = styled(IconTemplate)<{ colors: IColors }>`
    margin-right: ${rem(10)};
    cursor: pointer;

    svg {
        width: ${rem(30)};
        margin-top: ${rem(4)};

        path,
        rect,
        circle {
            fill: ${(props) => props.colors?.colorLine};
            stroke: ${(props) => props.colors?.colorLine};
        }
    }
`;

export const ContactMap = styled.div``;
